<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-mafiaways2">
      <div class="px-3 col-3 p-0">
        <div class="heading-mafiaways2">{{ $t('result.round') }}</div>
        <div class="text-subhead-mafiaways2">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mafiaways2">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-mafiaways2">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mafiaways2">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-mafiaways2">{{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mafiaways2">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-mafiaways2">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-mafiaways2 pt-3">
      <div class="text-games-mafiaways2">{{ 'Mafia Way II' }}</div>
      <div class="text-subgame-mafiaways2">{{ $t('mafiaways2.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 100px">
        <div class="wheel-wrapper multiplier-wrapper">
          <img v-if="isFreespin" class="multiplier-image" width="100%"
            :src="require(`../../assets/resultGame/mafiaways2/multiplier_free_${multiplier}.png`)" alt="">
          <img v-else class="multiplier-image" width="100%"
            :src="require(`../../assets/resultGame/mafiaways2/multiplier_normal_${multiplier}.png`)" alt="">
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white;">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-mafiaways2" @click="delCount()"></i>
        </div>
        <div class="table-mafiaways2 container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in reels[0]" :key="index">
                <td v-for="(col, i) in reels" :key="`${index}${i}`">
                  <img class="icon-symbol-mafiaways2"
                    :src="require(`../../assets/resultGame/mafiaways2/symbol_${col[index]}.png`)" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-mafiaways2" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-mafiaways2">
        <h1 v-if="isFreespin"> {{ $t("result.freespin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        <h1 v-else>{{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-mafiaways2">Feature Buy</div>
      <div v-if="winnings.length" class="col-12 justify-content-center d-flex flex-row">
        <div class="bet-box-mafiaways2 p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in winnings" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-mafiaways2 item">
                <div class="d-flex justify-content-start bet-wrapper-mafiaways2 item">
                  <img class="icon-detail-mafiaways2"
                    :src="require(`../../assets/resultGame/mafiaways2/symbol_${detail.symbol}.png`)" alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{ `${detail.row} ` + $t('result.kind') }}</p>
                    <p> {{ ` x${detail.count} ${detail.count > 1 ? `ways` : `way`
                      }` }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ detail.amount | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-mafiaways2',
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      reels: [],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      count: this.data.count,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      isEndRound: false,
      pages: 0
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-mafiaways2')[0].offsetHeight
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = result.multiplier
      this.isFreespin = (result.state === 'FREESPIN' || result.state === 'FREERESPIN')
      this.isRespin = result.state === 'RESPIN'

      this.reels = result.reels;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #431B05
    /* margin: 0; */
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -50px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
  transform: translate(55px, -26px);
}

.multiplier-image {
  width: 70%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-mafiaways2 {
  width: 100px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-mafiaways2 {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-mafiaways2 {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-mafiaways2 {
  background: #0c161f;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box-mafiaways2 {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-mafiaways2 .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box-mafiaways2 .bet-wrapper-mafiaways2:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-mafiaways2,
.result-wrapper {
  font-size: 35px;
}

.header-mafiaways2 {
  background: #F5DE71;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-mafiaways2>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-mafiaways2 {
  color: #000000;
  text-align: center;
}

.content-result-mafiaways2 {
  background: #391818;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-mafiaways2 {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-mafiaways2 {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-mafiaways2 {
  font-size: px;
  color: #5A5A5A;
  text-align: center;
}

.text-subgame-mafiaways2 {
  font-size: 20px;
  color: #FFD500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #FFF5BF;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-mafiaways2 {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-mafiaways2 {
  min-width: 600px;
  max-width: auto;
}

.table-mafiaways2 {
  z-index: 5;
  background-size: 570px 440px;
  /* set Bg Table HERE */
  width: 570px;
  height: 440px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 40px;
}

@media screen and (max-width: 1030px) {
  .table-mafiaways2 {
    background-size: 500px 400px;
    width: 500px;
    height: 380px;
    margin-top: 39px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }


  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -50px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 70%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-mafiaways2 {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-mafiaways2,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -50px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 70%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-mafiaways2,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-mafiaways2 {
    font-size: 18px;
  }

  .table-mafiaways2 {
    background-size: 470px 400px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -50px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 70%;
    transform: scale(0.9) translate(10px, 19px);
    margin-left: 21px;
  }

  .front-table-mafiaways2 {
    /* background: url('~@/assets/resultGame/mafiaways2/slot_slotmachine.png') no-repeat; */
    background-size: 470px 400px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
    /* padding-bottom: 35px; */
  }

  .text-subhead-mafiaways2 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-mafiaways2 {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -50px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }


  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4) translate(-156px, 10px);
    margin-left: 21px;
  }

  .header-mafiaways2>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-mafiaways2 {
    font-size: 12px;
  }

  .table-mafiaways2 {
    background-size: 250px 180px;
    width: 250px;
    height: 180px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-mafiaways2 {
    font-size: 14px;
  }

  .bet-box-mafiaways2 {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-mafiaways2 {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-mafiaways2,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-mafiaways2 {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-mafiaways2 {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }
}
</style>